import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";

export function PageHero({ eyebrow, title, description, image, imageAlt, primaryLabel = "Get a Quote", primaryHref = "/contact", testId }) {
  const actionClass = "inline-flex items-center gap-3 bg-industrial-yellow px-7 py-4 font-mono text-xs font-bold uppercase tracking-[0.2em] text-industrial-black transition-all hover:-translate-y-1 hover:hard-shadow-sm";
  const action = primaryHref.startsWith("#") ? (
    <a href={primaryHref} data-testid={`${testId}-quote-button`} className={actionClass}>{primaryLabel} <ArrowUpRight size={18} weight="bold" /></a>
  ) : (
    <Link to={primaryHref} data-testid={`${testId}-quote-button`} className={actionClass}>{primaryLabel} <ArrowUpRight size={18} weight="bold" /></Link>
  );
  return (
    <section className="blueprint-grid border-b border-industrial-line pt-20" data-testid={testId}>
      <div className="mx-auto grid max-w-[1500px] gap-0 px-5 py-16 sm:px-8 lg:grid-cols-12 lg:py-24">
        <div className="flex flex-col justify-center lg:col-span-7 lg:pr-14">
          <motion.p initial={{ opacity: 0, x: -18 }} animate={{ opacity: 1, x: 0 }} className="mb-6 flex items-center gap-3 font-mono text-xs font-semibold uppercase tracking-[0.3em] text-industrial-yellow">
            <span className="h-px w-12 bg-industrial-yellow" /> {eyebrow}
          </motion.p>
          <div className="overflow-hidden">
            <motion.h1 initial={{ y: "105%" }} animate={{ y: 0 }} transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }} className="font-heading text-4xl font-bold uppercase leading-[0.92] tracking-tighter text-industrial-text sm:text-5xl lg:text-6xl">
              {title}
            </motion.h1>
          </div>
          <motion.p initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.35 }} className="mt-7 max-w-2xl text-base leading-8 text-industrial-muted sm:text-lg">
            {description}
          </motion.p>
          <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.48 }} className="mt-9">
            {action}
          </motion.div>
        </div>
        <motion.div initial={{ opacity: 0, scale: 0.97 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8 }} className="spotlight-image relative mt-10 min-h-[360px] overflow-hidden border border-industrial-line lg:col-span-5 lg:mt-0">
          <img src={image} alt={imageAlt} className="h-full w-full object-cover grayscale-[20%] contrast-125" />
        </motion.div>
      </div>
    </section>
  );
}
